import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { SelectListItem } from '../../_models/common/select.list.item';

@Component({
  selector: 'app-drop-down-filter',
  templateUrl: './drop-down-filter.component.html',
  styleUrls: ['./drop-down-filter.component.scss']
})
export class DropDownFilterComponent implements OnInit {
  @Input() selectAll: string;
  @Input() maxItems: number;
  _descriptions: SelectListItem[];
  get descriptions(): SelectListItem[] { return this._descriptions; }
  @Input('descriptions')
  set descriptions(value: SelectListItem[]) {
    this._descriptions = value;
    this.setHiddenPropertyOfItems(this.descriptions, this.maxItems, this.showAll);
  }
  @Input() hideEmptyItems: boolean;
  @Input() collapsed: boolean;
  @Input() showAlways: boolean;
  @Input() multiSelect: boolean;
  @Output() filterChange: EventEmitter<SelectListItem> = new EventEmitter<SelectListItem>();
  selected: number;
  showAll = false;

  constructor() { }

  ngOnInit() {
  }

  getSelectedItem(): string {
    let total = this.descriptions.filter(d => d.selected).map(d => d.description).join(',');
    if (!total) { total = this.selectAll; }
    return total;
  }

  setSelectedItem(item: SelectListItem) {
    if (this.multiSelect) {
      item.selected = !item.selected;
    } else {
      this.descriptions.forEach(d => {
        d.selected = (item === d);
      });
    }
    this.filterChange.emit(item);
  }

  resetSelectedItems() {
    this.descriptions.forEach(d => d.selected = false);
    this.filterChange.emit(null);
  }

  hideWithOnlyCountedItem(): boolean {
    return !this.showAlways && this.descriptions.filter(d => d.count > 0).length === 1;
  }

  change(item: SelectListItem) {
    this.filterChange.emit(item);
  }

  setHiddenPropertyOfItems(items: SelectListItem[], count: number, showAll: boolean) {
    this.selected = this.getSelectedCount(this.descriptions);
    if (!count || showAll) {
      items.forEach(item => item.hidden = false);
    } else {
      const maxItems = count > this.selected ? count : this.selected;
      const topItems = items.slice().sort((item1, item2) => {
        if (item1.selected && !item2.selected) { return -1; }
        if (!item1.selected && item2.selected) { return 1; }
        if (item1.count > item2.count) { return -1; }
        if (item1.count < item2.count) { return 1; }
        return 0;
      }).slice(0, maxItems);

      items.forEach(item => {
        item.hidden = !topItems.includes(item);
      });
    }
  }

  getSelectedCount(descriptions: SelectListItem[]): number {
    if (descriptions) {
      return descriptions.reduce((count, item) => item.selected ? count + 1 : count, 0);
    }
    return 0;
  }

  collapse(): void {
    this.selected = this.getSelectedCount(this.descriptions);
    this.collapsed = !this.collapsed;
  }

  more() {
    this.showAll = !this.showAll;
    this.setHiddenPropertyOfItems(this.descriptions, this.maxItems, this.showAll);
  }

}
